import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcTeleworkerGateway = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M4 16a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H4Zm2 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.848 7.996a1.665 1.665 0 1 1-3.331 0 1.665 1.665 0 0 1 3.33 0Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.441 9.697a2.41 2.41 0 0 1 0-3.328.746.746 0 0 0-1.078-1.03 3.9 3.9 0 0 0 0 5.388.746.746 0 1 0 1.078-1.03Zm7.114-3.327a2.41 2.41 0 0 1 0 3.327.746.746 0 0 0 1.078 1.03 3.9 3.9 0 0 0 0-5.388.746.746 0 1 0-1.078 1.03Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4.792 8.033c0 1.408.55 2.76 1.535 3.767a.746.746 0 1 1-1.067 1.042 6.88 6.88 0 0 1 0-9.617.746.746 0 1 1 1.067 1.042 5.39 5.39 0 0 0-1.535 3.766ZM17.67 4.267a5.39 5.39 0 0 1 0 7.533.746.746 0 1 0 1.066 1.042 6.88 6.88 0 0 0 0-9.617.746.746 0 1 0-1.066 1.042Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcTeleworkerGateway");

export { IcTeleworkerGateway };
//# sourceMappingURL=ic-teleworker-gateway.js.map
